import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import PromotePlanChangeDialog from '../../../common/PromotePlanChangeDialog';
import { connect } from 'react-redux';
import { isIntegrateSalesforceTimelineStatus } from "../../../../utils/userOptionUtils";
import { SalesforceSettingDirectory, PromotePlanDialogTypes } from "../../../../constants/ComponentTypes";

const styles = () => ({
  root: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },

  detailButton: {
    border: "1px solid #D8DBDF",
    fontSize: "11px",
    minWidth: "54px",
    color: "#181819",
    padding: "10px 15px",
  },
});

/**
 * Salesforce連携設定がされていない場合のコンポーネント
 */
class SalesforceUnSetting extends React.Component {
  state = {
    [PromotePlanDialogTypes.SALESFORCE_TIMELINE_STATUS.flag]: false,
  }

  togglePromotePlanChangeDialog = (type) => {
    this.setState({
      [type["flag"]]: !(this.state[type["flag"]])
    });
  }

  renderPromotePlanChangeDialog = (type) => {
    return (
      <PromotePlanChangeDialog
        isOpen={this.state[type["flag"]]}
        type={type}
        toggleDialog={() => this.togglePromotePlanChangeDialog(type)}
        handlePlanChange={this.togglePlanDialog}
      />
    );
  };

  render() {
    const { classes, salesforceSettingDirectory } = this.props;

    return (
      <div className={classes.root} style={{ minHeight: "unset" }}>
        {(() => {
          if (salesforceSettingDirectory.value === SalesforceSettingDirectory.TIMELINE_STATUS.value && !isIntegrateSalesforceTimelineStatus(this.props.user)) {
            return (<Typography variant="subheading">
                    現在のプランではお使いいただけません。
                    <Button
                      color="primary"
                      className={classes.detailButton}
                      onClick={() => this.togglePromotePlanChangeDialog(PromotePlanDialogTypes.SALESFORCE_TIMELINE_STATUS)}>
                      詳細
                    </Button>
                  </Typography>)
          } else {
            return (<Typography variant="subheading">
                      {salesforceSettingDirectory.text}連携が設定されていません。
                      <Link
                        to={salesforceSettingDirectory.setup_path}
                        className={classes.link}
                      >
                        こちら
                      </Link>
                      で設定してください。
                    </Typography>)
          }
        })()}
        {this.renderPromotePlanChangeDialog(PromotePlanDialogTypes.SALESFORCE_TIMELINE_STATUS)}
      </div>
    );
  }
}

SalesforceUnSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  salesforceSettingDirectory: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(SalesforceUnSetting));




// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceUnSetting.jsx